/**
 * Shared PDP trust UI: business-day ship labels, timeline step dates, inline stock web component.
 * Loaded once from pb-value-props inline slot; timeline card calls window.pbPdpTrust.init().
 */
(function () {
  'use strict';

  function getBizDate(startDate, days) {
    var d = new Date(startDate);
    if (days === 0) {
      if (d.getDay() === 6) d.setDate(d.getDate() + 2);
      else if (d.getDay() === 0) d.setDate(d.getDate() + 1);
      return d;
    }
    var count = 0;
    while (count < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) count++;
    }
    return d;
  }

  function formatBusinessRange(min, max) {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var now = new Date();
    var d1 = getBizDate(now, min);
    var d2 = getBizDate(now, max);

    var today = new Date();
    var tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    var isMinToday = d1.toDateString() === today.toDateString();
    var isMaxToday = d2.toDateString() === today.toDateString();
    var isMinTom = d1.toDateString() === tomorrow.toDateString();
    var isMaxTom = d2.toDateString() === tomorrow.toDateString();

    if (isMinToday && isMaxToday) return 'Today';
    if (isMinTom && isMaxTom) return 'Tomorrow';

    var m1 = months[d1.getMonth()],
      day1 = d1.getDate();
    var m2 = months[d2.getMonth()],
      day2 = d2.getDate();
    if (d1.getTime() === d2.getTime()) return m1 + ' ' + day1;
    return m1 === m2 ? m1 + ' ' + day1 + '-' + day2 : m1 + ' ' + day1 + ' - ' + m2 + ' ' + day2;
  }

  function refreshStepDates() {
    document.querySelectorAll('[data-pb-step-range]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      if (isNaN(min) || isNaN(max)) return;
      el.textContent = formatBusinessRange(min, max);
    });
  }

  function refreshShipLabels() {
    document.querySelectorAll('[data-pb-ship-by]').forEach(function (h) {
      var min = parseInt(h.getAttribute('data-min'), 10);
      var max = parseInt(h.getAttribute('data-max'), 10);
      var template = h.getAttribute('data-template') || '';
      if (isNaN(min) || isNaN(max) || !template) return;
      var str = formatBusinessRange(min, max);
      h.innerHTML = template.replace('[Date]', '<span style="font-weight: 600;">' + str + '</span>');
    });
  }

  function unlockTimelineParents() {
    var root = document.querySelector('.timeline-root-container');
    if (!root) return;
    var parent = root.parentElement;
    while (parent && !parent.classList.contains('product-info-wrapper')) {
      if (parent.tagName === 'DIV') {
        parent.style.maxWidth = '100%';
        parent.style.width = '100%';
        parent.style.paddingLeft = '0';
        parent.style.paddingRight = '0';
        parent.style.marginTop = '0';
        parent.style.marginBottom = '0';
      }
      parent = parent.parentElement;
    }
  }

  function refreshAll() {
    refreshStepDates();
    refreshShipLabels();
    unlockTimelineParents();
  }

  window.pbPdpTrust = window.pbPdpTrust || {};
  window.pbPdpTrust.formatBusinessRange = formatBusinessRange;
  window.pbPdpTrust.refreshStepDates = refreshStepDates;
  window.pbPdpTrust.refreshShipLabels = refreshShipLabels;
  window.pbPdpTrust.unlockTimelineParents = unlockTimelineParents;
  window.pbPdpTrust.refreshAll = refreshAll;
  window.pbPdpTrust.init = refreshAll;

  document.addEventListener('shopify:section:load', refreshAll);

  if (!customElements.get('pb-inline-stock')) {
    class PbInlineStock extends HTMLElement {
      connectedCallback() {
        this.lowStockThreshold = parseInt(this.dataset.lowStockThreshold || '50', 10);
        this.showExactCount = this.dataset.showExactCount === 'true';
        this.setupVariantListener();
      }

      setupVariantListener() {
        var self = this;
        document.addEventListener('variant:change', function (event) {
          if (event.detail && event.detail.variant) {
            self.updateInventoryDisplay(event.detail.variant);
          }
        });

        document.querySelectorAll('variant-selects, variant-radios').forEach(function (selector) {
          selector.addEventListener('change', function () {
            var vid = selector.currentVariant && selector.currentVariant.id;
            if (vid) self.fetchVariantData(vid);
          });
        });
      }

      fetchVariantData(variantId) {
        var sectionEl = this.closest('.shopify-section');
        var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : '';
        if (!sectionId) return;

        var url = window.location.pathname + '?variant=' + variantId + '&section_id=' + sectionId;
        fetch(url)
          .then(function (r) {
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('pb-inline-stock .pb-stock-inline__content');
            var current = this.querySelector('.pb-stock-inline__content');
            if (fresh && current) {
              current.innerHTML = fresh.innerHTML;
            }
          }.bind(this))
          .catch(function () {});
      }

      updateInventoryDisplay(variant) {
        if (!variant) return;
        var content = this.querySelector('.pb-stock-inline__content');
        if (!content) return;

        var qty = variant.inventory_quantity || 0;
        var policy = variant.inventory_policy;
        var management = variant.inventory_management;

        var statusClass = 'pb-stock-inline__dot--in';
        var text = '';

        if (!management) {
          text = this.dataset.untrackedMessage || '';
        } else if (qty <= 0) {
          if (policy === 'continue') {
            text = this.dataset.backorderMessage || '';
            statusClass = 'pb-stock-inline__dot--in';
          } else {
            text = this.dataset.outOfStockMessage || '';
            statusClass = 'pb-stock-inline__dot--out';
          }
        } else if (qty <= this.lowStockThreshold) {
          statusClass = 'pb-stock-inline__dot--low';
          if (this.showExactCount) {
            text = qty + ' ' + (this.dataset.unitLabel || '');
          } else {
            var maxShow = parseInt(this.dataset.showQuantityWhenAtMost || '20', 10);
            if (qty > 0 && maxShow > 0 && qty <= maxShow) {
              text =
                qty === 1
                  ? this.dataset.quantityLeftOne || '1 product left'
                  : qty + ' ' + (this.dataset.quantityLeftMany || 'products left');
            } else {
              text = this.dataset.lowStockMessage || '';
            }
          }
        } else {
          text = this.showExactCount
            ? qty + ' ' + (this.dataset.unitLabel || '')
            : this.dataset.inStockMessage || '';
          statusClass = 'pb-stock-inline__dot--in';
        }

        var dot = content.querySelector('.pb-stock-inline__dot');
        var textEl = content.querySelector('.pb-stock-inline__text');
        if (dot) {
          dot.className = 'pb-stock-inline__dot ' + statusClass;
        }
        if (textEl) {
          textEl.textContent = text;
        }
      }
    }

    customElements.define('pb-inline-stock', PbInlineStock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }
})();
